module.exports = __webpack_public_path__ + "assets/media/lunch.7b738828.mp3";